import { cn } from '@/common/utils/cn'
import Spinner from '../Spinner'

interface LoadingSpinnerProps {
  isLoading: boolean
  className?: string
}

export default function LoadingSpinner({isLoading = false, className}: LoadingSpinnerProps) {

  if(!isLoading) return

  return (
    <div className={cn('flex gap-3 items-center', className)}>
      <Spinner />
    </div>
  )
}
